import React, { useState } from "react";

import { Heading, Modal, Stack } from "@seneca/senekit";

import shuffle from "seneca-common/utils/functions/random/shuffle";

import ImageVideo from "features/common/imageComponents/components/ImageVideo";
import { ModalPortal } from "features/common/modals/components/ModalNodeContext";

import styles from "./LocalStorageBlockedModal.module.scss";

type Props = {
  onCloseClick: () => void;
};

export default function LocalStorageBlockedModal({ onCloseClick }: Props) {
  const [gif] = useState(() => shuffle(gifs)[0]);

  return (
    <ModalPortal>
      <Modal onCloseClick={onCloseClick}>
        <Stack align="center">
          <Heading level="2">Cookies!</Heading>
          {/* @ts-ignore */}
          <ImageVideo src={gif} elementClassName={styles.gif} />
          <p className={styles.text}>
            It looks like you've blocked cookies. That's fine and you can keep
            using Seneca, however some features may not work as expected. To
            allow them again you'll need to go into your browser settings.
          </p>
        </Stack>
      </Modal>
    </ModalPortal>
  );
}

const gifs = [
  "https://media.giphy.com/media/1ngQorBCDcUFy/giphy.mp4",
  "https://media.giphy.com/media/nAErqE3k2C3fy/giphy.mp4",
  "https://media.giphy.com/media/l3vRmjIZpfYp8MLwA/giphy.mp4"
];
